/**
 * S3d: the server's `api/password_policy.py` minimum for a NEW password (register, reset, accept-invitation).
 * The server also refuses passwords on its bundled common-password list; that check is server-only and its
 * reason comes back as a `validation_failed` field message, which `describeApiError` shows as it is.
 */
export const MIN_PASSWORD_LENGTH = 12;
